const signupConstants = {
  SIGNUP_REQUEST: "SIGNUP_REQUEST",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  SIGNUP_FAILURE: "SIGNUP_FAILURE",
  SIGNUP_CLEAR: "SIGNUP_CLEAR",
};

export default signupConstants;
